import { Button, Dialog, DialogContent, Stack } from '@mui/material'
import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

import { CLOCK_RECHECK_EVENT, clockLabels, parseServerClock } from '../../utilities/clockSkew'
import './ClockSkewDialog.sass'

function ClockSkewDialog({ clockSkew = {}, email }) {
  const { t } = useTranslation()
  const {
    skewed = false,
    offsetMismatch = false,
    serverTime = null,
    localTime = null,
  } = clockSkew

  const localDt = parseServerClock(localTime) || DateTime.local()
  const serverDt = parseServerClock(serverTime)
  const labels = clockLabels(localDt, serverDt)

  const onRecheck = () => {
    window.dispatchEvent(new CustomEvent(CLOCK_RECHECK_EVENT))
  }

  return (
    <Dialog
      open={Boolean(skewed) && Boolean(email)}
      disableEscapeKeyDown
      className="clock-skew-dialog"
    >
      <DialogContent>
        <Stack className="clock-skew-dialog-content" alignItems="center">
          <Stack className="clock-skew-dialog-body" alignItems="center">
            <Stack className="clock-skew-dialog-heading" alignItems="center" gap={2}>
              <WarningAmberIcon className="clock-skew-dialog-icon" />
              <h2>{t('clock_skew_title')}</h2>
            </Stack>
            <p>{t('clock_skew_description')}</p>
            {offsetMismatch && (
              <p>{t('clock_skew_timezone_hint')}</p>
            )}
            <Stack className="clock-skew-dialog-times" gap={1}>
              <p>
                <span>{t('clock_skew_expected')}</span>
                <strong>{labels.expected}</strong>
              </p>
              <p>
                <span>{t('clock_skew_actual')}</span>
                <strong>{labels.local}</strong>
              </p>
            </Stack>
          </Stack>
          <Button
            fullWidth
            variant="contained"
            onClick={onRecheck}
          >
            {t('clock_skew_recheck')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

const mapStateToProps = state => ({
  clockSkew: state.utilities?.clockSkew,
  email: state.profile?.email,
})

export default connect(mapStateToProps)(ClockSkewDialog)
